// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  background: linear-gradient(to bottom, transparent 0%, black 100%);
  z-index: 1;
}

.carousel-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  padding-left: 13rem;
  color: #fff;
  z-index: 2;
}

.carousel-content h3 {
  margin: 0;
  font-size: 28px;
  font-weight: bold;
  line-height: 1.2;
}

.carousel-content button {
  margin-top: 20px;
}

.carousel-item {
  height: 580px !important;
 
}

button:active {
  outline: none; /* remove focus outline */
  background-color: #f5f5f5; /* set background color to a different value */
}

.carousel-inner {
  transition: transform 600ms ease-in-out;
  justify-content: flex-start;

}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(0);
}

.carousel-item-next.carousel-item-left,
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(0);
}

.carousel-item-prev.carousel-item-right,
.active.carousel-item-right {
  transform: translateX(100%);
}
`, "",{"version":3,"sources":["webpack://./src/components/slider/slider.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kEAAkE;EAClE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;;AAE1B;;AAEA;EACE,aAAa,EAAE,yBAAyB;EACxC,yBAAyB,EAAE,8CAA8C;AAC3E;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;;AAE7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;AAC7B","sourcesContent":[".carousel-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: start;\r\n  align-items: center;\r\n  background: linear-gradient(to bottom, transparent 0%, black 100%);\r\n  z-index: 1;\r\n}\r\n\r\n.carousel-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  padding: 20px;\r\n  padding-left: 13rem;\r\n  color: #fff;\r\n  z-index: 2;\r\n}\r\n\r\n.carousel-content h3 {\r\n  margin: 0;\r\n  font-size: 28px;\r\n  font-weight: bold;\r\n  line-height: 1.2;\r\n}\r\n\r\n.carousel-content button {\r\n  margin-top: 20px;\r\n}\r\n\r\n.carousel-item {\r\n  height: 580px !important;\r\n \r\n}\r\n\r\nbutton:active {\r\n  outline: none; /* remove focus outline */\r\n  background-color: #f5f5f5; /* set background color to a different value */\r\n}\r\n\r\n.carousel-inner {\r\n  transition: transform 600ms ease-in-out;\r\n  justify-content: flex-start;\r\n\r\n}\r\n\r\n.carousel-item-next:not(.carousel-item-left),\r\n.active.carousel-item-right {\r\n  transform: translateX(0);\r\n}\r\n\r\n.carousel-item-next.carousel-item-left,\r\n.active.carousel-item-left {\r\n  transform: translateX(-100%);\r\n}\r\n\r\n.carousel-item-prev:not(.carousel-item-right),\r\n.active.carousel-item-left {\r\n  transform: translateX(0);\r\n}\r\n\r\n.carousel-item-prev.carousel-item-right,\r\n.active.carousel-item-right {\r\n  transform: translateX(100%);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
